<p-panel header="{{ 'register' | translate }}">
  <form [formGroup]="registerForm" (submit)="onRegister()">
    <app-loader *ngIf="loaderRegistring || isLoading2"></app-loader>
    <div *ngIf="!loaderRegistring && !isLoading2">
      <div *ngIf="!isRegistered && !isCodeSend">
        <div style="margin-top: 10px"></div>
        <span class="ui-float-label">
          <input
            type="text"
            formControlName="login"
            pInputText
            style="width: 100%"
            [ngClass]="
              login.invalid &&
              (login.dirty || login.touched) &&
              'errorMessageBorder'
            "
          />
          <label for="float-input">{{ "login_name" | translate }}</label>
        </span>
        <div style="margin-top: 20px"></div>
        <span class="ui-float-label">
          <input
            type="text"
            formControlName="name"
            pInputText
            style="width: 100%"
            [ngClass]="
              name.invalid &&
              (name.dirty || name.touched) &&
              'errorMessageBorder'
            "
          />
          <label for="float-input">{{ "name" | translate }}</label>
        </span>
        <div style="margin-top: 20px"></div>
        <span class="ui-float-label">
          <input
            type="text"
            formControlName="surname"
            pInputText
            style="width: 100%"
            [ngClass]="
              surname.invalid &&
              (surname.dirty || surname.touched) &&
              'errorMessageBorder'
            "
          />
          <label for="float-input">{{ "surname" | translate }}</label>
        </span>
        <div style="margin-top: 20px"></div>
        <span class="ui-float-label">
          <input
            type="text"
            formControlName="phone"
            pInputText
            style="width: 100%"
            [ngClass]="
              phone.invalid &&
              (phone.dirty || phone.touched) &&
              'errorMessageBorder'
            "
          />
          <label for="float-input">{{ "register_phoneNo" | translate }}</label>
        </span>

        <div style="margin-top: 20px"></div>
        <span class="ui-float-label">
          <input
            type="text"
            formControlName="email"
            pInputText
            style="width: 100%"
            [ngClass]="
              email.invalid &&
              (email.dirty || email.touched) &&
              'errorMessageBorder'
            "
          />
          <label for="float-input">{{ "register_email" | translate }}</label>
        </span>
        <div style="margin-top: 20px"></div>
        <span class="ui-float-label">
          <input
            type="password"
            formControlName="password"
            pInputText
            style="width: 100%"
            [ngClass]="
              password.invalid &&
              (password.dirty || password.touched) &&
              'errorMessageBorder'
            "
          />
          <label for="float-input">{{ "login_password" | translate }}</label>
        </span>

        <div style="margin-top: 20px"></div>
        <span class="ui-float-label">
          <input
            type="password"
            formControlName="c_password"
            pInputText
            style="width: 100%"
            [ngClass]="
              c_password.invalid &&
              (c_password.dirty || c_password.touched) &&
              'errorMessageBorder'
            "
          />
          <label for="float-input">{{
            "login_password_repeat" | translate
          }}</label>
        </span>


        <div class="agreement">
           
            <div><p-checkbox formControlName="agree1" [binary]="true"></p-checkbox>&nbsp;</div>
            <div style="position: relative;top: 1px;"><span>{{'register_accpet1' | translate}}</span> <a  [routerLink]="['/regulamin']" style="margin-left: 3px;">{{'register_accpet2' | translate}}</a> </div>
          
         
        </div>

        <div class="agreement">
           
          <div><p-checkbox formControlName="agree2" [binary]="true"></p-checkbox>&nbsp;</div>
          <div style="position: relative;top: 1px;left:3px"><span>{{'register_accpet3' | translate}}</span> 
            <a style="margin-left: 3px;" [routerLink]="['/polityka-prywatnosci']">{{'register_accpet4' | translate}}</a> 
          
            <span >{{'register_accpet5' | translate}}</span> 

          
          </div>
        
       
      </div>

        <div>
          <div class="ui-g">
            <div class="ui-g-6 ui-xl-6">
              <div>
                <a routerLink="/forgotpassword">{{
                  "forgot_password" | translate
                }}</a>
              </div>
              <div>
                <a routerLink="/login"> {{ "login" | translate }} >></a>
              </div>
            </div>
            <div class="ui-g-6 ui-xl-6 ui-g-nopad">
              <div style="text-align: right; margin-top: 10px">
                <button
                  pButton
                  type="submit"
                  label="{{ 'login_login' | translate }}"
                  [disabled]="registerForm.invalid"
                  class="ui-button-raised ui-button-success"
                ></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

  <div *ngIf="isCodeSend && !isRegistered">
    <h2 class="su">{{ "enter_code_from_email" | translate }}</h2>
    <div class="ui-g" >
      <div class="ui-g-3"></div>
      <div class="ui-g-6">
        <span class="ui-float-label">
          <input id="code-input" [(ngModel)]="code" type="text" pInputText style="width: 100%;">
          <label for="code-input">{{ 'enter_forgot_password_code' | translate }}</label>
        </span>

        <div style="height: 20px;"></div>
        <app-primary-button label="{{ 'submit' | translate }}" type="button" (action)="verifyCode()" [disabled]="isLoading2 || !code" ></app-primary-button>
      </div>
      <div class="ui-g-3"></div>
    </div>
  </div>

  <div class="confirmationRegister" *ngIf="isRegistered">
    <h2 class="su">{{ "register_ok" | translate }}</h2>
    <span>
      <a [routerLink]="['/']">{{ "buy_note" | translate }}>> </a>
    </span>
  </div>
</p-panel>
